import Notification from './index';
import notificationLevels from './notificationLevels';
import notificationSeverities from './notificationSeverities';
import _ from 'underscore';

const sortBySeverity = function(notification) {
    if (notification.severity === notificationSeverities.error) { return 1; };
    return 0;
};

const sortByTimestamp = function(notification) {
    return notification.timestamp;
};

function NotificationCollection(notifications)
{
    const unsortedNotifications = notifications || [];

    this.notifications = _(unsortedNotifications).chain()
                            .sortBy(sortBySeverity)
                            .sortBy(sortByTimestamp).value();

    this.top = _(this.notifications).find(n => n.level === notificationLevels.top);
    this.page = _(this.notifications).find(n => n.level === notificationLevels.page);
    
    this.with = function(notification) {
        checkNotificationType(notification);
        const newNotifications = [notification].concat(this.notifications);
        return new NotificationCollection(newNotifications);
    };

    this.without = function(notification) {
        checkNotificationType(notification);
        const newNotifications = _(this.notifications).without(notification);
        return new NotificationCollection(newNotifications);
    };

    this.withoutType = function(notificationType) {
        const newNotifications = _(this.notifications).filter(n => n.type !== notificationType);
        return new NotificationCollection(newNotifications);
    };
};

const checkNotificationType = function(notification) {
    if (!(notification instanceof Notification)) {
        throw 'Invalid notification type';
    }
};

export default NotificationCollection;


// WEBPACK FOOTER //
// ./src/js/notification/notificationCollection.js